import {TableColumnConfig} from '../table';
import {TablePluginMessage} from './table-plugin';

export enum CommonTablePluginMessageType {
    SET_COLUMNS_CONFIG         = 'SET_COLUMNS_CONFIG',
    SET_COLUMNS_CONFIG_PREVIEW = 'SET_COLUMNS_CONFIG_PREVIEW'
}

export interface TablePluginMsgColumnsConfig extends TablePluginMessage {
    type: CommonTablePluginMessageType.SET_COLUMNS_CONFIG;
    columnsConfig: TableColumnConfig[];
}

export interface TablePluginMsgColumnsConfigPreview extends TablePluginMessage {
    type: CommonTablePluginMessageType.SET_COLUMNS_CONFIG_PREVIEW;
    columnsConfig: TableColumnConfig[];
}
